import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;

	> h1 {
		font-size: 1.6rem;
		font-family: nunito-bold;
		color: ${color.interface.white};
	}
`;

export const noProduct = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;

	> p {
		font-size: 1.3rem;
		color: white;
	}
`;

export const list = styled.div`
	width: 100%;
	overflow: auto;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: flex-start;
`;

export const product = styled.div`
	max-width: 100px;
	min-width: 100px;
	height: 100px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 5px;
	padding: 10px;
	background-color: rgba(255, 255, 255, 0.5);
	border-radius: 5px;

	> p {
		font-family: nunito-bold;
		color: ${color.interface.white};
	}

	> img {
		width: 50px;
		height: 50px;
		border-radius: 5px;
		background-color: ${color.interface.lightGray2};
	}
`;
